import api from "../../api/axios";

export function sendWebAppOpen() {
  const tg = window?.Telegram?.WebApp;
  if (!tg) return;  // not inside Telegram WebApp

  // only send once per session
  if (sessionStorage.getItem("webapp_open_sent")) return;

  // raw initData string from Telegram
  const initData = tg.initData || "";
  // if there is no user block in initData, do not send the log
  if (!initData.includes("user=")) return;
  // optional marker from URL
  const params = new URLSearchParams(window.location.search);
  const marker = params.get("entry_source");

  api.post("/accounts/tg_webapp_open/", { initData, marker })
     .catch(err => console.warn(
       "webapp_open log failed",
       err.response?.status,
       err.response?.data ?? err
     ));

  // mark as sent to avoid duplicates
  sessionStorage.setItem("webapp_open_sent", "1");
}